module.exports = __webpack_public_path__ + "img/icon-button-add.64592494.svg";